import { ZoomIn } from "lucide-react";
import FadeImg from "@/components/FadeImg";

export function normalizeImages(list) {
  return (list || [])
    .map((it) =>
      typeof it === "string"
        ? { url: it, caption: "", alt: "" }
        : { url: it.url || "", caption: it.caption || "", alt: it.alt || "" }
    )
    .filter((it) => it.url);
}

export function Figure({ image, fallbackCaption = "", onOpen, className = "", aspectClass = "", imgClassName = "", eager = false, testid }) {
  const caption = image.caption || "";
  return (
    <figure className="m-0">
      <button
        type="button"
        onClick={onOpen}
        data-testid={testid}
        aria-label={`Enlarge image${caption ? `: ${caption}` : ""}`}
        className={`group relative block w-full text-left frame-clip spotlight ${aspectClass} ${className}`}
      >
        <FadeImg
          src={image.url}
          alt={image.alt || caption || fallbackCaption}
          className={imgClassName}
          loading={eager ? "eager" : "lazy"}
          fetchPriority={eager ? "high" : undefined}
        />
        <span className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 group-focus-visible:opacity-100 transition-opacity duration-300 pointer-events-none">
          <span className="bg-ink/70 text-paper rounded-full p-3 backdrop-blur-sm">
            <ZoomIn size={18} strokeWidth={1.5} />
          </span>
        </span>
      </button>
      {caption && (
        <figcaption className="mt-2 font-mono text-[10px] uppercase tracking-[0.2em] text-ink/45 leading-relaxed">
          {caption}
        </figcaption>
      )}
    </figure>
  );
}
